/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_a53ae8d2"]'><theme-container><div :style="[(style)] | transRpxStyle" :class='["base-container"]'><slot></slot></div></theme-container></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_a53ae8d2"}'>

view.base-container,
div.base-container
  background-color #f7f8fa
.base-container
  width 100%
  height 100%
  padding 20px
  box-sizing border-box
  overflow auto
  -webkit-overflow-scrolling touch
  &::after
    display block
    content ' '
    width 100%
    height 1px
    background-color transparent
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_a53ae8d2"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_a53ae8d2"}
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexa53ae8d2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findexa53ae8d2%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_a53ae8d2"],
    ctorType: "component",
    outputPath: "components/indexa53ae8d2/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'theme-container':getComponent(require("../theme-container/index.mpx?isComponent&outputPath=components%2Findex714cd67f%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>